import React, { useContext } from 'react';
import styled from 'styled-components';
import NotificationsPanel from 'components/NotificationsPanel';
import NotificationsContext from 'contexts/NotificationsContext';
import NavItem from './NavItem';

const NewNotificationsDot = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background-color: var(--color-brand-primary);
`;

const NotificationsButton = () => {
  const { openPanel, hasUnSeenNotifications } =
    useContext(NotificationsContext);

  return (
    <>
      <NavItem
        icon={'bell'}
        iconColor={'var(--color-icon-secondary)'}
        onClick={openPanel}
        isActiveOverride={false}
        to={'#'}
        renderExtra={
          hasUnSeenNotifications ? <NewNotificationsDot /> : undefined
        }
      />
      <NotificationsPanel isCard={false} />
    </>
  );
};

export default NotificationsButton;
